import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Checkbox from '../Checkbox/Checkbox';

class CheckboxExample extends Component {

  state = {
    checked: true,
    label: 'This is the checkbox label'
  };

  onChange = e => this.setState({ checked: e.target.value, indeterminate: false });

  onChangeProps = e => this.setState(e.target.value);

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChangeProps} defaultProps={Checkbox.defaultProps} propTypes={Checkbox.propTypes} propValues={this.state}/>
        <Checkbox {...this.state} onChange={this.onChange}/>
        <div className="checkboxes">
          <h3>States</h3>
          <Checkbox checked readOnly label="Checked enabled"/>
          <Checkbox checked readOnly disabled label="Checked disabled"/>
          <Checkbox label="Unchecked"/>
          <Checkbox disabled label="Unchecked disabled"/>
          <Checkbox indeterminate label="Indeterminate"/>
          <Checkbox disabled indeterminate label="Indeterminate disabled"/>
        </div>
        <SourceCode querySelector=".checkbox-example > .core-checkbox"/>
      </Example>
    );
  }

}

CheckboxExample.tags = 'toggle switch indeterminate';

export default CheckboxExample;
